import React, { useState } from "react";

const InventoryCard = ({ usedMeters, totalCapacity, onUpdateCapacity, availableMeters, usagePercentage }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempCapacity, setTempCapacity] = useState(totalCapacity);

  const handleSave = async () => {
    const success = await onUpdateCapacity(Number(tempCapacity));
    if (success) setIsEditing(false);
  };

  return (
    <div className="inventory-card">
      {/* الرسم البياني الدائري */}
      <div 
        className="progress-circle" 
        style={{ "--percentage": `${usagePercentage}%` }}
      >
        <div className="progress-inner">
          <span className="progress-text">{usagePercentage}%</span>
          <span className="progress-label">مستخدم</span>
        </div>
      </div>

      {/* معلومات الأمتار */}
      <div className="info-box">
        <div>المتوفر: <strong>{availableMeters}</strong> م</div>
        <small style={{color: "#777"}}>المستخدم: {usedMeters} م</small>
      </div>

      {/* قسم تعديل السعة */}
      <div className="capacity-section">
        <label>السعة الكلية للمخزن</label>
        
        {isEditing ? (
          <div className="edit-mode-box">
            <input 
              type="number" 
              className="capacity-input"
              value={tempCapacity}
              onChange={(e) => setTempCapacity(e.target.value)}
            />
            <div className="action-buttons">
              <button className="btn-save" onClick={handleSave}>حفظ</button>
              <button className="btn-cancel" onClick={() => setIsEditing(false)}>إلغاء</button>
            </div>
          </div>
        ) : (
          <div className="view-mode-box">
            <span className="capacity-value">{totalCapacity}</span>
            <button className="btn-edit" onClick={() => {
              setTempCapacity(totalCapacity);
              setIsEditing(true);
            }}>تعديل</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default InventoryCard;